<template>
  <div class="users-manager-create">
    <v-text-field class="mb-2" label="Name" dense required v-model="form.name">
      <template #label>
        <span class="red--text"><strong>* </strong></span>Name
      </template>
    </v-text-field>
    <v-text-field
      class="mb-2"
      label="Email"
      dense
      required
      v-model="form.email"
    >
      <template #label>
        <span class="red--text"><strong>* </strong></span>Email
      </template>
    </v-text-field>
    <p class="subtitle-2 font-weight-light">Phone Number</p>
    <vue-phone-number-input
      v-model="form.phone_number"
      class="mb-3"
      :default-country-code="form.phone_country"
      no-example
      :only-countries="['US']"
      color="#F9B417"
      valid-color="#004df9"
      :rules="errors.phone_number"
      @update="formatPhoneNo($event)"
    />
    <p class="phone-number-error body-2 red--text">
      <span v-if="isPhoneNoError || errors.phone_number"
        >Phone number is invalid, please input correct phone number</span
      >
      <span v-else class="white--text">Phone Number</span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'UsersManagerCreate',
  components: {},
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone_number: '',
        phone_country: '',
      },
      isPhoneNoError: false,
      errors: [],
    };
  },
  watch: {
    form: {
      handler() {
        this.$emit('changeInput', this.form);
      },
      deep: true,
    },
  },
  methods: {
    formatPhoneNo(event) {
      this.isPhoneNoError = false;

      if (event.phoneNumber == undefined) {
        return this.isPhoneNoError;
      }

      if (event.phoneNumber && !event.isValid) {
        return (this.isPhoneNoError = true);
      }

      this.form.phone_country = event.countryCode;
      this.form.phone_code = '+' + event.countryCallingCode;
      this.nationalNumber = event.nationalNumber;
      this.form.phone_number = this.nationalNumber;
    },
  },
};
</script>

<style lang="stylus">
.users-manager-create
    margin 3rem 0
</style>
